import styled, { css } from 'styled-components';

export const Container = styled.div`
  left: 0;
  right: 0;
  position: absolute;
  padding: 0 20px 20px;

  ${(props) =>
    props.contextClassName
      ? css`
          width: calc(100% - 35px);
        `
      : css`
          width: 100%;
        `}
`;
